import React from "react";
import {
  Button,
  Container,
  Typography,
} from "@material-ui/core";

const SaleBanners: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <div className="sale-banner-grid">
        <div
          className="sale-banner sale-banner-one"
        >
          <div className="sale-banner-content">
            <Typography className="sale-percent">
              %50
            </Typography>

            <Typography className="sale-title">
              All Fruit and vegetable
            </Typography>

            <Typography className="sale-subtitle">
              Sale 50% Off
            </Typography>

            <Button>
              Shop now
            </Button>
          </div>
        </div>

        <div
          className="sale-banner sale-banner-two"
        >
          <div className="sale-banner-content">
            <Typography className="sale-percent">
              %50
            </Typography>

            <Typography className="sale-title">
              SALE 50% OFF
            </Typography>

            <Typography className="sale-subtitle">
              Organic Juice
            </Typography>

            <Button>
              Shop now
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SaleBanners;